<script setup lang="ts">
import './assets/style.scss'
import { useSchedule } from '@/entities/Schedule/Main'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { VIcons } from '@/shared/ui'
import { ObjectTypes } from '@/entities/Object'
import { useTranslate } from '@/shared/lib'

const schedule = useSchedule()
const route = useRoute()
const { trs } = useTranslate()

const schedule_id = computed(() => route.params.schedule_id as string)
schedule.loadData(schedule_id)

/** Вычисляем иконку */
const icon = computed(() => {
  if (!schedule.data) return ObjectTypes[1].icon

  return ObjectTypes[schedule.data.object_type_id].icon
})

/** Вычисляем подпись */
const description = computed(() => {
  if (!schedule.data) return ''

  let value = ''

  if (schedule.data.description) {
    value += `${schedule.data.description}, `
  }

  if (schedule.data.object_type_id === 1) {
    value += `${trs('itf.outputs_count')}: ${schedule.data.output_count}`
  }

  return value
})
</script>

<template>
  <div class="w-schedule-header" v-if="schedule.data">
    <h1 class="w-schedule-header__title">
      <VIcons :type="icon" />
      {{ schedule.data.name }}
    </h1>

    <div class="w-schedule-header__description">
      {{ description }}
    </div>
  </div>
</template>
